module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-intercom-spa/gatsby-browser.js'),
      options: {"plugins":[],"delay_timeout":5000},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","name":"GraphCMS","short_name":"GraphCMS","start_url":"/","background_color":"#090E24","theme_color":"#6563FD","display":"standalone","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"7fe6664e39b0f4626654c28c48525319"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"exclude":["/"],"noHash":true,"noQueryString":true,"noTrailingSlash":true,"siteUrl":"https://graphcms-com-fxszpie31.vercel.app"},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"gatsbyRemarkPlugins":["gatsby-remark-copy-linked-files",{"resolve":"gatsby-remark-images","options":{"quality":80,"linkImagesToOriginal":false,"wrapperStyle":"border: 1px solid #F0F2F7; box-shadow: 0 2px 6px rgba(0,0,0,.08)"}},{"resolve":"gatsby-remark-video","options":{"preload":"auto","muted":true,"autoplay":true,"playsinline":true,"controls":true,"loop":true}},{"resolve":"gatsby-remark-autolink-headers","options":{"className":"anchor flex items-center justify-center text-primary-300 dark:text-gray-200 -ml-6 absolute opacity-0"}},"gatsby-remark-responsive-iframe"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx-embed/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
